/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { Row, Col, Modal, Button } from 'reactstrap';
import { View, Text, StyleSheet, ScrollView } from 'react-native-web';
import { connect } from 'react-redux';
import { ICartProduct } from '@ddot/AddToCartCommon/lib/entities';
import { css } from '@emotion/react';

import Actions from 'Redux/Actions';
import Selectors from 'Redux/Selectors';

// import Button from 'Components/Button';
import { RootState } from 'Redux/store';

import Image from 'Components/Image';
import { RightArrow } from 'Icons/Icons';
import colors from 'Themes/colors';

interface UnavailableProductsProps {
    products: ICartProduct[];
    clearStockCheckUnavailableProducts(): void;
    removeFromCart(product: ICartProduct): void;
    isOpen: boolean;
}

const ModalUnavailableProducts = (props: UnavailableProductsProps): JSX.Element | null => {
    const {
        products, clearStockCheckUnavailableProducts, removeFromCart, isOpen,
    } = props;

    const [soldOutIndex, setSoldOutIndex] = React.useState(0);

    useEffect(() => {
        if (soldOutIndex === products.length) {
            products.forEach((product) => {
                removeFromCart(product);
            });

            clearStockCheckUnavailableProducts();
            setSoldOutIndex(0);
        }
    }, [soldOutIndex]);

    if (!products.length) return null;
    const groupedStockUnavailable: any[] = [];
    products?.forEach((product) => {
        const p = groupedStockUnavailable.find((gsu) => gsu.id === product.id);
        if (p) {
            p.quantity += 1;
        } else {
            groupedStockUnavailable.push({
                id: product.id,
                name: product.name,
                quantity: 1,
            });
        }
    });

    const onBack = () => {
        clearStockCheckUnavailableProducts();
    };

    const onContinue = () => {
        // const { removeFromCart } = props;

        setSoldOutIndex(soldOutIndex + 1);

        // products.forEach((product) => {
        //     removeFromCart(product);
        // });

        // clearStockCheckUnavailableProducts();
    };

    const renderSoldOutModal = () => {
        return (
            products.map((product, index) => {
                const { id, name, imageUrl } = product;
                if (index !== soldOutIndex) return null;
                return (
                    <div css={modalDiv}>
                        <div css={imageContainer}>
                            <Image
                                css={productImg}
                                url={imageUrl?.[0] || 'This is an image'}
                                alt='Product Img'
                            />
                        </div>
                        <div>
                            <p css={soldOutHeader}>
                                Sold Out Item
                            </p>
                        </div>
                        <Text style={{ width: '90%', textAlign: 'center', marginBottom: 20 }}>
                            Oops! The
                            {' '}
                            <strong>
                                {name}
                            </strong>
                            {' '}

                            just sold out. We&rsquo;ve gone ahead and removed it from your cart.
                        </Text>
                        <Button onClick={onContinue} css={buttonContainer}>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <p style={{ margin: 0, textAlign: 'center' }}>Continue</p>
                                <RightArrow css={buttonIcons} />
                            </div>
                        </Button>
                    </div>
                );
            }));
    };

    return (

        <Modal
            isOpen={isOpen}
            css={modalContainer}
            className='modal-dialog-centered modal-xl'
        >
            {renderSoldOutModal()}
        </Modal>
    );
};

const modalContainer = css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '.modal-content': {
        borderRadius: '8px !important',
    },

    '@media(max-width: 300px)': {
        width: '60%',
    },

    '@media(min-width: 980px)': {
        width: '30%',
    },
});

const modalDiv = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '40px',
});

const imageContainer = css({
    width: '30%',
    height: '30%',
    borderRadius: 4,
    border: '1px solid #E6DFD8',
});

const productImg = css({
    width: '100%',
    height: '100%',
});

const buttonContainer = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '18px AcuminRPro',
    color: 'white',
    backgroundColor: '#064E72',
    borderRadius: '12px',
    height: 65,
    width: '100%',
    transition: 'ease 0.2s',
    '&:hover,&:focus': {
        border: '2px solid #064E72',
        backgroundColor: colors.white,
        fill: colors.white,
        color: '#064E72',

    },

});

const buttonIcons = css({
    width: '25px',
    height: '25px',
    marginLeft: '15px',
    color: 'unset',

    '@media(min-width:992px)': {
        width: '25px',
        height: '25px',
        marginTop: -5,
    },
});

const soldOutHeader = css({
    fontSize: 32,
    fontWeight: 700,
    fontFamily: 'Playfair',
    color: '#064E72',
    marginTop: 32,
});

const mapStateToProps = (state: RootState) => ({
    products: Selectors.getUiStockCheckUnavailableProduct(state),

});

const mapDispatchToProps = (dispatch: any) => ({
    removeFromCart: (product: ICartProduct) => dispatch(Actions.cartRemoveFromCart({ product })),
    clearStockCheckUnavailableProducts: () => dispatch(Actions.uiClearStockCheckUnavailableProducts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalUnavailableProducts);
